module.exports = __webpack_public_path__ + "static/img/person1.65169ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/person1.png
// module id = iwrK
// module chunks = 1